export const buildAppEmbedActivationUrl = (shopOrigin: string, handle: string): string => {
	const shopHandle = shopOrigin.replace('.myshopify.com', '');
	const clientId = process.env.REACT_APP_SHOPIFY_API_KEY;
	return `https://admin.shopify.com/store/${shopHandle}/themes/current/editor?context=apps&activateAppId=${clientId}/${handle}`;
};
